import { A as Z, B as J } from "./ButtonNode-FcSe8TmV.js";
import { resolveComponent as l, openBlock as i, createElementBlock as u, createElementVNode as d, Fragment as x, renderList as A, createBlock as g, normalizeClass as S, withCtx as a, createVNode as r, createCommentVNode as v, renderSlot as w, useCssVars as R, toDisplayString as _, createTextVNode as $, withDirectives as O, vModelText as P, defineAsyncComponent as Q, resolveDynamicComponent as U } from "vue";
import { _ as f, c as X, N as H, S as ee, b as te } from "./main-DCvt4qAp.js";
import oe from "vuedraggable";
const ne = {
  name: "ActiveButtonToolbar",
  props: {
    showToolbar: Boolean,
    isDeleteButtonVisible: Boolean
  },
  data() {
    return {
      toolbarActions: [
        {
          name: "drag",
          alt: this.$t("builder.content.button.dragHandleIcon"),
          icon: "drag-handle"
        },
        {
          name: "edit-link",
          alt: this.$t("builder.content.button.editLink"),
          icon: "link"
        },
        {
          name: "delete",
          alt: this.$t("builder.content.button.deleteButton"),
          icon: "trashcan"
        }
      ]
    };
  },
  computed: {
    filteredActions() {
      return this.isDeleteButtonVisible ? this.toolbarActions : this.toolbarActions.filter(({ name: e }) => e !== "delete");
    }
  }
}, ie = {
  key: 0,
  class: "toolbar-wrapper"
}, se = { class: "toolbar" };
function le(e, t, n, p, s, o) {
  const h = l("a-icon"), c = l("a-button");
  return i(), u("div", {
    onMouseover: t[0] || (t[0] = (m) => e.$emit("set-active-button")),
    onMouseleave: t[1] || (t[1] = (m) => e.$emit("remove-active-button"))
  }, [
    n.showToolbar ? (i(), u("div", ie, [
      d("div", se, [
        (i(!0), u(x, null, A(o.filteredActions, (m, y) => (i(), g(c, {
          key: y,
          class: S(["action-button", `${m.name}-button`]),
          variant: "none",
          style: { padding: "0" },
          onClick: (C) => e.$emit(m.name)
        }, {
          default: a(() => [
            r(h, {
              icon: `24:${m.icon}`
            }, null, 8, ["icon"])
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))), 128))
      ])
    ])) : v("", !0),
    w(e.$slots, "default", {}, void 0, !0)
  ], 32);
}
const re = /* @__PURE__ */ f(ne, [["render", le], ["__scopeId", "data-v-fe7d6a61"]]), ae = {}, ce = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ue(e, t) {
  return i(), u("svg", ce, t[0] || (t[0] = [
    d("path", {
      d: "M6 15.1405L5 19.1405L9 18.1405L17 10.1405C19.5 7.64051 16.5 4.64053 14 7.14053L6 15.1405Z",
      stroke: "white",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]));
}
const q = /* @__PURE__ */ f(ae, [["render", ue]]), de = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q
}, Symbol.toStringTag, { value: "Module" })), E = {
  name: "IconsList",
  props: {
    icons: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    colors: {
      type: Object,
      default: () => {
      }
    },
    activeIconIdx: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconTextColor() {
      var e;
      return (e = this.colors) == null ? void 0 : e.iconFillColor;
    },
    iconBackgroundColor() {
      var e;
      return (e = this.colors) == null ? void 0 : e.iconBgColor;
    }
  },
  methods: {
    selectIcon(e, t) {
      return this.$emit(
        "selectIcon",
        {
          iconId: e.id,
          name: e.name,
          icon: e.icon
        },
        t
      );
    }
  }
}, M = () => {
  R((e) => ({
    "1b8cad90": e.iconBackgroundColor,
    "20024d31": e.iconTextColor
  }));
}, z = E.setup;
E.setup = z ? (e, t) => (M(), z(e, t)) : M;
const me = { class: "icon-rows-container" }, pe = {
  key: 0,
  class: "header"
}, he = ["id", "onClick"], ve = { class: "raw-svg" }, be = ["innerHTML"], ge = ["for"];
function _e(e, t, n, p, s, o) {
  const h = l("a-text");
  return i(), u("div", null, [
    d("div", me, [
      n.header ? (i(), u("span", pe, _(n.header), 1)) : v("", !0),
      d("div", {
        class: S([n.type, "icon-section"])
      }, [
        (i(!0), u(x, null, A(n.icons, (c, m) => (i(), u("button", {
          key: `${n.type}-icon-${c.id}`,
          class: "icon-with-text"
        }, [
          d("div", {
            id: `${n.type}-icon-${m}`,
            class: S([{ activeIcon: n.activeIconIdx === m }, "icon-wrapper"]),
            onClick: () => o.selectIcon(c, m)
          }, [
            d("span", ve, [
              d("span", {
                innerHTML: c.icon
              }, null, 8, be)
            ])
          ], 10, he),
          c.name ? (i(), u("label", {
            key: 0,
            for: `${n.type}-icon-${m}`,
            class: "icon-text"
          }, [
            r(h, { variant: "regular-s" }, {
              default: a(() => [
                $(_(c.name), 1)
              ]),
              _: 2
            }, 1024)
          ], 8, ge)) : v("", !0)
        ]))), 128))
      ], 2)
    ])
  ]);
}
const Ie = /* @__PURE__ */ f(E, [["render", _e], ["__scopeId", "data-v-f9f6064a"]]), fe = {
  name: "SearchInput",
  data() {
    return {
      criteria: ""
    };
  },
  mounted() {
    this.criteria = this.default;
  }
}, ye = { id: "search" }, ke = ["placeholder"];
function Ce(e, t, n, p, s, o) {
  return i(), u("div", ye, [
    O(d("input", {
      "onUpdate:modelValue": t[0] || (t[0] = (h) => s.criteria = h),
      placeholder: e.$t("builder.content.button.searchPlaceholder"),
      type: "text",
      onKeyup: t[1] || (t[1] = (h) => e.$emit("search", s.criteria))
    }, null, 40, ke), [
      [P, s.criteria]
    ])
  ]);
}
const Be = /* @__PURE__ */ f(fe, [["render", Ce], ["__scopeId", "data-v-8fc6dce8"]]), Se = {
  name: "GlobalIconEditor",
  components: {
    SearchInput: Be,
    IconsList: Ie
  },
  props: {
    currentIcons: {
      type: Object,
      default: () => {
      }
    },
    activeIconIdx: {
      type: Number,
      default: 0
    },
    colors: {
      type: Object,
      default: () => {
      }
    },
    icons: {
      type: Object,
      default: () => ({ global_icons: [], custom_icons: [] })
    }
  },
  data() {
    return {
      activeIcon: {},
      activeIdx: 0,
      activeNew: {},
      currentIconsLocal: [],
      globalIcons: [],
      customIcons: [],
      allIcons: [],
      searchCriteria: "",
      globalSearchResults: [],
      customSearchResults: []
    };
  },
  computed: {
    hasCustomIcons() {
      return this.customIcons.length > 0;
    },
    activeIndexByType() {
      return {
        global: this.findActiveIconIndexInListByType(
          "global",
          this.activeIcon.iconId
        ),
        custom: this.findActiveIconIndexInListByType(
          "custom",
          this.activeIcon.iconId
        )
      };
    }
  },
  created() {
    this.currentIconsLocal = X(this.currentIcons), this.activeIcon = this.currentIconsLocal[this.activeIconIdx], this.activeIdx = this.activeIconIdx, this.globalIcons = this.icons.global_icons || [], this.customIcons = this.icons.custom_icons || [], this.allIcons = [...this.globalIcons, ...this.customIcons];
  },
  methods: {
    hide() {
      this.$emit("close");
    },
    update() {
      this.$emit("update", this.currentIconsLocal), this.hide();
    },
    selectCurrent(e, t) {
      this.activeIcon = e, this.activeIdx = t;
    },
    replaceIcon(e) {
      this.activeIcon = e, this.currentIconsLocal[this.activeIdx] = e;
    },
    findActiveIconIndexInListByType(e, t) {
      return this[`${e}Icons`].findIndex((n) => t === n.id);
    },
    filterIconsByType(e) {
      return this[`${e}Icons`].filter(
        (t) => t.name.toLowerCase().includes(this.searchCriteria.toLowerCase())
      );
    },
    onSearch(e) {
      this.searchCriteria = e, e && (this.globalSearchResults = this.filterIconsByType("global"), this.customSearchResults = this.filterIconsByType("custom"));
    }
  }
}, $e = { class: "icon-row" }, Le = { class: "replace-search-row" }, we = { class: "icon-replace-message" }, Te = {
  key: 0,
  class: "icon-libraries"
}, xe = { class: "icon-libraries" };
function Ae(e, t, n, p, s, o) {
  const h = l("a-dialog-header"), c = l("IconsList"), m = l("SearchInput"), y = l("a-dialog-content"), C = l("a-button"), b = l("a-dialog-footer"), T = l("a-dialog");
  return i(), u("div", null, [
    r(T, {
      show: !0,
      size: "l",
      onClose: o.hide
    }, {
      default: a(() => [
        r(h, null, {
          default: a(() => [
            $(_(e.$t("builder.content.button.selectIcon")), 1)
          ]),
          _: 1
        }),
        r(y, null, {
          default: a(() => [
            d("div", $e, [
              r(c, {
                icons: s.currentIconsLocal,
                type: "current",
                colors: n.colors,
                "active-icon-idx": s.activeIdx,
                onSelectIcon: o.selectCurrent
              }, null, 8, ["icons", "colors", "active-icon-idx", "onSelectIcon"]),
              d("div", Le, [
                d("h3", we, _(e.$t("builder.content.button.replaceIcon")), 1),
                r(m, {
                  class: "search-input",
                  onSearch: o.onSearch
                }, null, 8, ["onSearch"])
              ]),
              o.hasCustomIcons ? (i(), u("div", Te, [
                r(c, {
                  icons: s.searchCriteria ? s.customSearchResults : s.customIcons,
                  type: "custom",
                  colors: n.colors,
                  "active-icon-idx": o.activeIndexByType.custom,
                  header: e.$t("builder.content.button.customIconLibrary"),
                  onSelectIcon: o.replaceIcon
                }, null, 8, ["icons", "colors", "active-icon-idx", "header", "onSelectIcon"])
              ])) : v("", !0),
              d("div", xe, [
                r(c, {
                  icons: s.searchCriteria ? s.globalSearchResults : s.globalIcons,
                  type: "global",
                  colors: n.colors,
                  "active-icon-idx": o.activeIndexByType.global,
                  header: e.$t("builder.content.button.iconLibrary"),
                  onSelectIcon: o.replaceIcon
                }, null, 8, ["icons", "colors", "active-icon-idx", "header", "onSelectIcon"])
              ])
            ])
          ]),
          _: 1
        }),
        r(b, null, {
          default: a(() => [
            r(C, {
              variant: "primary",
              onClick: o.update
            }, {
              default: a(() => [
                $(_(e.$t("builder.continue")), 1)
              ]),
              _: 1
            }, 8, ["onClick"]),
            r(C, {
              variant: "secondary",
              onClick: o.hide
            }, {
              default: a(() => [
                $(_(e.$t("builder.cancel")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onClose"])
  ]);
}
const Ee = /* @__PURE__ */ f(Se, [["render", Ae], ["__scopeId", "data-v-9ad1da29"]]), De = (e, t) => {
  const n = e[t];
  return n ? typeof n == "function" ? n() : Promise.resolve(n) : new Promise((p, s) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(s.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, Ne = {
  props: {
    selected: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    icon() {
      return this.config.icon;
    }
  }
};
function Me(e, t, n, p, s, o) {
  return i(), u("button", {
    class: S([{ selected: n.selected }, "button"]),
    onClick: t[0] || (t[0] = (h) => e.$emit("selected", n.config.value))
  }, [
    w(e.$slots, "icon", {}, void 0, !0),
    w(e.$slots, "text", {}, void 0, !0)
  ], 2);
}
const F = /* @__PURE__ */ f(Ne, [["render", Me], ["__scopeId", "data-v-86341b80"]]), ze = {
  name: "DefaultButton",
  components: {
    ButtonContainer: F
  },
  props: {
    selected: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    icon() {
      return this.config.icon;
    },
    svgIcon() {
      return Q(
        () => De(/* @__PURE__ */ Object.assign({ "../../../../assets/icons/AddLinkBtnIcon.vue": () => import("./AddLinkBtnIcon-ClxHjGEH.js"), "../../../../assets/icons/ArrowButtonIcon.vue": () => import("./ButtonNode-FcSe8TmV.js").then((e) => e.a), "../../../../assets/icons/ArrowPointerIcon.vue": () => import("./ArrowPointerIcon-CkO5ZNb8.js"), "../../../../assets/icons/BackIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.ax), "../../../../assets/icons/ButtonDragIcon.vue": () => import("./ButtonDragIcon-DKk36NUW.js"), "../../../../assets/icons/ButtonLinkIcon.vue": () => import("./ButtonLinkIcon-DhhpqgRQ.js"), "../../../../assets/icons/ButtonRegularIcon.vue": () => import("./ButtonRegularIcon-C8MpW0Mb.js"), "../../../../assets/icons/ButtonSquareIcon.vue": () => import("./ButtonSquareIcon-DQvRtV4M.js"), "../../../../assets/icons/ButtonStyle1Icon.vue": () => import("./ButtonStyle1Icon-Cr9j1F5q.js"), "../../../../assets/icons/ButtonStyle2Icon.vue": () => import("./ButtonStyle2Icon-DSBBlr21.js"), "../../../../assets/icons/CenterAlignIcon.vue": () => import("./CenterAlignIcon-6k3y5sDs.js"), "../../../../assets/icons/CopyIcon.vue": () => import("./CopyIcon-B5UiIiar.js"), "../../../../assets/icons/CropIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.av), "../../../../assets/icons/CutIcon.vue": () => import("./CutIcon-C8_zRUzd.js"), "../../../../assets/icons/DeleteWithBackGroudIcon.vue": () => import("./DeleteWithBackGroudIcon-BsJNYmeS.js"), "../../../../assets/icons/DeplicateIcon.vue": () => import("./DeplicateIcon-DghoFefn.js"), "../../../../assets/icons/DragHandleIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.ay), "../../../../assets/icons/EditIcon.vue": () => Promise.resolve().then(() => de), "../../../../assets/icons/EmptySectionIcon.vue": () => import("./EmptySectionIcon-Cdy9aNd0.js"), "../../../../assets/icons/ErrorIcon.vue": () => import("./ErrorIcon-CH5fWuir.js"), "../../../../assets/icons/FavoriteIcon.vue": () => import("./FavoriteIcon-DdA_1yZm.js"), "../../../../assets/icons/FocalPointIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.au), "../../../../assets/icons/InfoIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.aw), "../../../../assets/icons/LeftAlignIcon.vue": () => import("./LeftAlignIcon-BicYu5yP.js"), "../../../../assets/icons/PasteIcon.vue": () => import("./PasteIcon-C9DfcMVs.js"), "../../../../assets/icons/RedoIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.aB), "../../../../assets/icons/ResizerIcon.vue": () => import("./ResizerIcon-DtgjqBCz.js"), "../../../../assets/icons/UndoIcon.vue": () => import("./main-DCvt4qAp.js").then((e) => e.aA) }), `../../../../assets/icons/${this.icon.name}.vue`)
      );
    }
  }
}, Ve = {
  key: 0,
  class: "icon"
}, je = { class: "name" };
function Re(e, t, n, p, s, o) {
  const h = l("ButtonContainer");
  return i(), g(h, {
    class: S({ "no-icon": !o.icon }),
    selected: n.selected,
    config: n.config,
    onSelected: t[0] || (t[0] = (c) => e.$emit("selected", n.config.value))
  }, {
    icon: a(() => [
      o.icon ? (i(), u("div", Ve, [
        (i(), g(U(o.svgIcon)))
      ])) : v("", !0)
    ]),
    text: a(() => [
      d("div", je, _(n.config.name), 1)
    ]),
    _: 1
  }, 8, ["class", "selected", "config"]);
}
const Oe = /* @__PURE__ */ f(ze, [["render", Re], ["__scopeId", "data-v-8e999a7f"]]), D = {
  components: {
    ButtonContainer: F
  },
  props: {
    selected: {
      type: Boolean,
      default: !1
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    backgroundColor() {
      return this.config.theme.backgroundColor;
    },
    textColor() {
      return this.config.theme.textColor;
    },
    borderColor() {
      return this.config.theme.borderColor ? `${this.config.theme.borderColor} 1px solid` : "";
    }
  }
}, V = () => {
  R((e) => ({
    "497bf7da": e.backgroundColor,
    "4e0f81f4": e.textColor,
    "2cc3e2d5": e.borderColor
  }));
}, j = D.setup;
D.setup = j ? (e, t) => (V(), j(e, t)) : V;
const Pe = { class: "icon" }, Ue = { class: "name" };
function He(e, t, n, p, s, o) {
  const h = l("a-text"), c = l("ButtonContainer");
  return i(), g(c, {
    selected: n.selected,
    config: n.config,
    onSelected: t[0] || (t[0] = (m) => e.$emit("selected", n.config.value))
  }, {
    icon: a(() => [
      d("div", Pe, [
        r(h, { variant: "h5" }, {
          default: a(() => [
            $(_(e.$t("builder.controls.theme.aUppercase")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    text: a(() => [
      d("div", Ue, _(n.config.name), 1)
    ]),
    _: 1
  }, 8, ["selected", "config"]);
}
const qe = /* @__PURE__ */ f(D, [["render", He], ["__scopeId", "data-v-73ab4caa"]]), Fe = {
  name: "CustomSelectInput",
  components: {
    DefaultButton: Oe,
    ButtonTheme: qe,
    NodeControl: H
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    optionsType: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: ""
    }
  },
  methods: {
    isSelected(e) {
      return this.value === e.value;
    }
  }
}, Ge = { class: "options-container" };
function Ke(e, t, n, p, s, o) {
  const h = l("NodeControl");
  return i(), g(h, null, {
    title: a(() => [
      d("h4", null, _(n.title), 1)
    ]),
    content: a(() => [
      d("div", Ge, [
        (i(!0), u(x, null, A(n.options, (c) => (i(), g(U(n.optionsType), {
          key: c.name,
          selected: o.isSelected(c),
          config: c,
          class: "option",
          onSelected: t[0] || (t[0] = (m) => e.$emit("selected", m))
        }, null, 40, ["selected", "config"]))), 128))
      ])
    ]),
    _: 1
  });
}
const We = /* @__PURE__ */ f(Fe, [["render", Ke], ["__scopeId", "data-v-366efdeb"]]), Ye = {
  name: "ButtonControl",
  components: {
    SidebarHeader: ee,
    CustomSelectInput: We,
    NodeControl: H
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },
    hasIcons: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    node() {
      return this.modelValue;
    }
  }
}, Ze = { key: 1 }, Je = { key: 2 };
function Qe(e, t, n, p, s, o) {
  const h = l("SidebarHeader"), c = l("CustomSelectInput"), m = l("a-toggle"), y = l("NodeControl"), C = l("portal");
  return i(), g(C, {
    to: o.node.id
  }, {
    default: a(() => [
      r(h, {
        title: o.node.name,
        onCloseSidebar: t[0] || (t[0] = (b) => e.$emit("close-sidebar"))
      }, null, 8, ["title"]),
      r(c, {
        title: e.$t("builder.controls.button.type"),
        "options-type": "DefaultButton",
        options: [
          {
            name: e.$t("builder.controls.button.typeRegular"),
            value: "regular",
            icon: {
              name: "ButtonRegularIcon"
            }
          },
          {
            name: e.$t("builder.controls.button.typeSquare"),
            value: "square",
            icon: {
              name: "ButtonSquareIcon"
            }
          },
          {
            name: e.$t("builder.controls.button.typeLink"),
            value: "link",
            icon: {
              name: "ButtonLinkIcon"
            }
          }
        ],
        value: o.node.properties.type,
        onSelected: t[1] || (t[1] = (b) => e.$emit("update", "type", b))
      }, null, 8, ["title", "options", "value"]),
      o.node.properties.type !== "link" ? (i(), g(c, {
        key: 0,
        title: e.$t("builder.controls.button.theme"),
        "options-type": "ButtonTheme",
        options: [
          {
            name: e.$t("builder.controls.button.themeLight"),
            value: "light",
            theme: {
              backgroundColor: "var(--color-main-10)",
              textColor: "var(--color-main)"
            }
          },
          {
            name: e.$t("builder.controls.button.themeDark"),
            value: "dark",
            theme: {
              backgroundColor: "var(--color-main)",
              textColor: "var(--primary-white)"
            }
          },
          {
            name: e.$t("builder.controls.button.themeOutline"),
            value: "outline",
            theme: {
              borderColor: "var(--color-main)",
              backgroundColor: "var(--primary-white)",
              textColor: "var(--primary-dark)"
            }
          }
        ],
        value: o.node.properties.theme,
        onSelected: t[2] || (t[2] = (b) => e.$emit("update", "theme", b))
      }, null, 8, ["title", "options", "value"])) : v("", !0),
      o.node.properties.type === "regular" ? (i(), u("div", Ze, [
        r(c, {
          title: e.$t("builder.controls.button.size"),
          "options-type": "DefaultButton",
          options: [
            {
              name: e.$t("builder.controls.button.sizeRegular"),
              value: "regular"
            },
            {
              name: e.$t("builder.controls.button.sizeLarge"),
              value: "large"
            }
          ],
          value: o.node.properties.size,
          onSelected: t[3] || (t[3] = (b) => e.$emit("update", "size", b))
        }, null, 8, ["title", "options", "value"]),
        r(y, null, {
          title: a(() => [
            d("h4", null, _(e.$t("builder.controls.button.pill")), 1)
          ]),
          control: a(() => [
            r(m, {
              id: "pill-shape-toggle",
              "model-value": o.node.properties.pillShape,
              "onUpdate:modelValue": t[4] || (t[4] = () => e.$emit("update", "pillShape", !o.node.properties.pillShape))
            }, null, 8, ["model-value"])
          ]),
          _: 1
        })
      ])) : v("", !0),
      o.node.properties.type === "square" ? (i(), u("div", Je, [
        r(c, {
          title: e.$t("builder.controls.button.style"),
          "options-type": "DefaultButton",
          options: [
            {
              name: "1",
              value: "1",
              icon: {
                name: "ButtonStyle1Icon"
              }
            },
            {
              name: "2",
              value: "2",
              icon: {
                name: "ButtonStyle2Icon"
              }
            }
          ],
          value: o.node.properties.style,
          onSelected: t[5] || (t[5] = (b) => e.$emit("update", "style", b))
        }, null, 8, ["title", "value"]),
        n.hasIcons ? (i(), g(y, { key: 0 }, {
          title: a(() => [
            d("h4", null, _(e.$t("builder.controls.button.icon")), 1)
          ]),
          control: a(() => [
            r(m, {
              id: "icon-toggle",
              "model-value": o.node.properties.hasIcons,
              disabled: o.node.properties.style === "2",
              "onUpdate:modelValue": t[6] || (t[6] = (b) => e.$emit("update", "hasIcons", b))
            }, null, 8, ["model-value", "disabled"])
          ]),
          _: 1
        })) : v("", !0)
      ])) : v("", !0),
      r(c, {
        title: e.$t("builder.controls.button.align"),
        "options-type": "DefaultButton",
        options: [
          {
            name: e.$t("builder.controls.button.alignLeft"),
            value: "left",
            icon: {
              name: "LeftAlignIcon"
            }
          },
          {
            name: e.$t("builder.controls.button.alignCenter"),
            value: "center",
            icon: {
              name: "CenterAlignIcon"
            }
          }
        ],
        value: o.node.properties.alignment,
        onSelected: t[7] || (t[7] = (b) => e.$emit("update", "alignment", b))
      }, null, 8, ["title", "options", "value"])
    ]),
    _: 1
  }, 8, ["to"]);
}
const Xe = /* @__PURE__ */ f(Ye, [["render", Qe]]), et = {
  methods: {
    resizeTextarea() {
      this.$nextTick(() => {
        const e = this.$el.nextElementSibling;
        e.style.height = "auto", e.style.height = `${e.scrollHeight}px`, e.style.overflowY = e.value ? "unset" : "hidden";
      });
    }
  },
  mounted() {
    this.resizeTextarea(), this.$el.nextElementSibling.addEventListener("input", this.resizeTextarea);
  },
  beforeUnmount() {
    this.$el.nextElementSibling.removeEventListener(
      "input",
      this.resizeTextarea
    );
  }
};
function tt(e, t, n, p, s, o) {
  return w(e.$slots, "default");
}
const ot = /* @__PURE__ */ f(et, [["render", tt]]), nt = {
  name: "EditableButtonNode",
  components: {
    ActiveButtonToolbar: re,
    ArrowButtonIcon: Z,
    ButtonNodeControl: Xe,
    draggable: oe,
    ResizableTextarea: ot,
    ButtonNode: J,
    EditIcon: q,
    IconEditor: Ee
  },
  inject: ["state"],
  props: {
    modelValue: {
      type: Object,
      default: () => {
      }
    },
    isActiveNode: Boolean,
    isInsideSharedContentLayout: Boolean
  },
  data() {
    return {
      activeButton: null,
      editingButton: null,
      linkPayload: {},
      iconIdx: 0,
      isDragging: !1,
      isTyping: !1,
      showEditLinkDialog: !1,
      showIconEditorDialog: !1,
      typingTimer: null,
      linkButtonIndex: 0
    };
  },
  beforeUnmount() {
    clearTimeout(this.typingTimer);
  },
  computed: {
    node() {
      return this.modelValue;
    },
    currentAddedIcons() {
      return this.node.content.buttons.map((e) => ({
        icon: e.icon,
        iconId: e.iconId
      }));
    },
    iconEditorColors() {
      const e = {
        dark: "var(--color-main)",
        light: "var(--color-main-10)",
        outline: "var(--primary-white)"
      };
      return {
        iconFillColor: this.node.properties.theme === "dark" ? "var(--primary-white)" : "var(--color-main)",
        iconBgColor: e[this.node.properties.theme] || "var(--primary-white)"
      };
    },
    iconsLibrary() {
      var e, t, n, p;
      return ((p = (n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n[this.node.type]) == null ? void 0 : p.icons) || [];
    },
    hasIcons() {
      var e, t, n, p;
      return ((t = (e = this.iconsLibrary) == null ? void 0 : e.global_icons) == null ? void 0 : t.length) > 0 || ((p = (n = this.iconsLibrary) == null ? void 0 : n.custom_icons) == null ? void 0 : p.length) > 0;
    },
    textareaMaxLength() {
      var e, t, n;
      return (n = (t = (e = this.state) == null ? void 0 : e.builder) == null ? void 0 : t.customProperties) == null ? void 0 : n[this.node.type].textareaMaxLength;
    }
  },
  methods: {
    addNewButton() {
      this.node.content.buttons.push(te());
    },
    editButtonLink(e, t) {
      this.editingButton = e, this.linkButtonIndex = t, this.linkPayload = {
        name: e.title,
        href: e.link,
        target: e.newTab ? "_blank" : ""
      }, this.showEditLinkDialog = !0;
    },
    openIconModal(e) {
      this.iconIdx = e, this.showIconEditorDialog = !0;
    },
    onLinkModalSubmit({ name: e, href: t, target: n }) {
      this.node.content.buttons.splice(this.linkButtonIndex, 1, {
        ...this.editingButton,
        title: e,
        link: t,
        newTab: n === "_blank"
      }), this.clearEditLinkDialog();
    },
    clearEditLinkDialog() {
      this.editingButton = null, this.linkPayload = {}, this.showEditLinkDialog = !1;
    },
    textareaChanged() {
      clearTimeout(this.typingTimer), this.isTyping = !0, this.typingTimer = setTimeout(() => {
        this.isTyping = !1;
      }, 500);
    },
    updateNodeProperties(e, t) {
      var n;
      (n = this.$refs.resizableTextarea) == null || n.resizeTextarea(), this.node.properties[e] = t;
    },
    updateIcons(e) {
      const t = this.node.content.buttons.map((n, p) => ({
        ...n,
        ...e[p]
      }));
      this.node.content.buttons = t;
    }
  }
}, it = { class: "button-area" }, st = ["onClick"], lt = {
  key: 0,
  class: "empty-custom-icon"
}, rt = ["innerHTML"], at = {
  key: 1,
  class: "style-2-bar"
}, ct = ["onUpdate:modelValue", "maxlength", "rows", "cols", "placeholder"];
function ut(e, t, n, p, s, o) {
  const h = l("EditIcon"), c = l("ResizableTextarea"), m = l("ArrowButtonIcon"), y = l("a-icon"), C = l("ActiveButtonToolbar"), b = l("a-button"), T = l("draggable"), G = l("ButtonNodeControl"), K = l("a-link-dialog"), N = l("portal"), W = l("IconEditor"), Y = l("ButtonNode");
  return i(), g(Y, {
    "model-value": o.node,
    "is-inside-shared-content-layout": n.isInsideSharedContentLayout
  }, {
    default: a((L) => [
      r(T, {
        list: o.node.content.buttons,
        "item-key": "id",
        "ghost-class": "ghost-class",
        class: "buttons-draggable",
        handle: ".drag-button",
        group: "pb-button-node",
        onStart: t[2] || (t[2] = (I) => s.isDragging = !0),
        onEnd: t[3] || (t[3] = (I) => s.isDragging = !1)
      }, {
        item: a(({ element: I, index: B }) => [
          d("div", it, [
            r(C, {
              class: "active-button-toolbar",
              "show-toolbar": s.activeButton === B && n.isActiveNode,
              "is-delete-button-visible": o.node.content.buttons.length > 1,
              onDelete: (k) => o.node.content.buttons.splice(B, 1),
              onEditLink: (k) => o.editButtonLink(I, B),
              onSetActiveButton: (k) => s.activeButton = B,
              onRemoveActiveButton: t[1] || (t[1] = (k) => s.activeButton = null)
            }, {
              default: a(() => [
                d("div", {
                  class: S(["button", L.buttonClasses])
                }, [
                  L.showCustomIcon ? (i(), u("div", {
                    key: 0,
                    class: "custom-icon-wrapper",
                    onClick: (k) => o.openIconModal(B)
                  }, [
                    s.activeButton === B && n.isActiveNode ? (i(), u("div", lt, [
                      r(h, { class: "edit-icon" })
                    ])) : (i(), u("span", {
                      key: 1,
                      class: "custom-icon",
                      innerHTML: I.icon
                    }, null, 8, rt))
                  ], 8, st)) : v("", !0),
                  L.isStyle2Square ? (i(), u("hr", at)) : v("", !0),
                  r(c, { ref: "resizableTextarea" }, {
                    default: a(() => [
                      O((i(), u("textarea", {
                        "onUpdate:modelValue": (k) => I.title = k,
                        class: "title-text",
                        key: o.node.properties.size,
                        maxlength: o.textareaMaxLength,
                        rows: I.title.split(`
`).length,
                        cols: I.title.length ? I.title.length + 5 : 15,
                        placeholder: e.$t("builder.content.button.textAreaPlaceholder"),
                        onInput: t[0] || (t[0] = (...k) => o.textareaChanged && o.textareaChanged(...k))
                      }, null, 40, ct)), [
                        [P, I.title]
                      ])
                    ]),
                    _: 2
                  }, 1536),
                  L.isStyle2Square ? (i(), g(m, {
                    key: 2,
                    class: "arrow-button",
                    "fill-color": "var(--color-main)",
                    "show-border": o.node.properties.theme !== "dark"
                  }, null, 8, ["show-border"])) : v("", !0),
                  o.node.properties.type === "link" ? (i(), g(y, {
                    key: 3,
                    icon: "24:carret-right",
                    color: "var(--color-main)"
                  })) : v("", !0)
                ], 2),
                I.title.length >= o.textareaMaxLength ? (i(), u("span", {
                  key: 0,
                  class: S(["character-limit", {
                    "limit-reached": I.title.length >= o.textareaMaxLength,
                    "is-typing": s.isTyping
                  }])
                }, [
                  d("strong", null, _(I.title.length), 1),
                  $("/" + _(o.textareaMaxLength) + " " + _(e.$t("builder.content.button.characters")), 1)
                ], 2)) : v("", !0)
              ]),
              _: 2
            }, 1032, ["show-toolbar", "is-delete-button-visible", "onDelete", "onEditLink", "onSetActiveButton"]),
            n.isActiveNode && !s.isDragging && B === o.node.content.buttons.length - 1 ? (i(), g(b, {
              key: 0,
              class: "add-button-wrapper",
              variant: "none",
              "aria-label": e.$t("builder.content.button.addButton"),
              onClick: o.addNewButton
            }, {
              default: a(() => [
                r(y, { icon: "24:circle-plus" })
              ]),
              _: 1
            }, 8, ["aria-label", "onClick"])) : v("", !0)
          ])
        ]),
        _: 2
      }, 1032, ["list"]),
      n.isActiveNode ? (i(), g(G, {
        key: 0,
        "model-value": o.node,
        "has-icons": o.hasIcons,
        onUpdate: o.updateNodeProperties,
        onCloseSidebar: t[4] || (t[4] = (I) => e.$emit("close-sidebar"))
      }, null, 8, ["model-value", "has-icons", "onUpdate"])) : v("", !0),
      s.showEditLinkDialog ? (i(), g(N, {
        key: 1,
        to: "root-dialog-container"
      }, {
        default: a(() => [
          r(K, {
            link: s.linkPayload,
            "max-length": 40,
            "allow-remove-link": !1,
            "allow-relative": "",
            "allow-line-breaks": "",
            onSubmit: o.onLinkModalSubmit,
            onClose: o.clearEditLinkDialog
          }, null, 8, ["link", "onSubmit", "onClose"])
        ]),
        _: 1
      })) : v("", !0),
      s.showIconEditorDialog ? (i(), g(N, {
        key: 2,
        to: "root-dialog-container"
      }, {
        default: a(() => [
          r(W, {
            "current-icons": o.currentAddedIcons,
            "active-icon-idx": s.iconIdx,
            colors: o.iconEditorColors,
            icons: o.iconsLibrary,
            onUpdate: o.updateIcons,
            onClose: t[5] || (t[5] = (I) => s.showIconEditorDialog = !1)
          }, null, 8, ["current-icons", "active-icon-idx", "colors", "icons", "onUpdate"])
        ]),
        _: 1
      })) : v("", !0)
    ]),
    _: 1
  }, 8, ["model-value", "is-inside-shared-content-layout"]);
}
const vt = /* @__PURE__ */ f(nt, [["render", ut], ["__scopeId", "data-v-bea8a425"]]);
export {
  vt as default
};
